/* HALE — custom blend builder (individual mix product only).
   Activates ONLY on a product page that has a «1 грам» (per-gram) variant. */
(function(){
  if((document.body.className||'').indexOf('template-product') === -1) return;

  var STEPS = [50, 70, 100, 130];
  var MIN = 20, MAX = 500;

  function money(v){
    return v.toFixed(2).replace(/\.00$/,'').replace('.', ',') + ' \u20b4';
  }

  function boot(){
    var root = document.querySelector('.hale .pinfo');
    if(!root || root.dataset.blend) return;

    var sel = root.querySelector('#pdpVariant');
    if(!sel) return;

    var gramOpt = null;
    [].forEach.call(sel.options, function(o){
      var t = (o.textContent||'').trim().toLowerCase();
      if(!gramOpt && /^1\s*(\u0433|\u0433\u0440\u0430\u043c)/.test(t)) gramOpt = o;
    });
    if(!gramOpt) return;
    root.dataset.blend = '1';

    var perGram = parseFloat((gramOpt.getAttribute('data-price')||'').replace(/[^\d.,]/g,'').replace(',','.')) || 0;
    if(!perGram){
      [].forEach.call(sel.options, function(o){
        var m = (o.textContent||'').match(/(\d+)\s*\u0433/);
        var p = parseFloat((o.getAttribute('data-price')||'').replace(/[^\d.,]/g,'').replace(',','.'));
        if(!perGram && m && p) perGram = p / parseInt(m[1],10);
      });
    }

    var css = ''
    + '.hale .blend{margin-top:14px;}'
    + '.hale .blend-lbl{display:block;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--muted);margin-bottom:8px;}'
    + '.hale .blend-pills{display:flex;flex-wrap:wrap;gap:8px;}'
    + '.hale .blend-pill{font-family:var(--sans);font-size:13.5px;padding:9px 16px;border-radius:30px;border:1px solid var(--line);background:transparent;color:var(--ink);cursor:pointer;transition:.2s;}'
    + '.hale .blend-pill:hover{border-color:var(--accent);}'
    + '.hale .blend-pill.on{background:var(--accent);color:var(--on-accent);border-color:var(--accent);}'
    + '.hale .blend-custom{display:none;align-items:center;gap:8px;margin-top:10px;}'
    + '.hale .blend-custom.on{display:flex;}'
    + '.hale .blend-custom input{width:96px;padding:9px 12px;border:1px solid var(--line);border-radius:10px;background:var(--bg-2);color:var(--ink);font-family:var(--sans);font-size:14px;outline:none;}'
    + '.hale .blend-custom input:focus{border-color:var(--accent);}'
    + '.hale .blend-custom span{font-size:12.5px;color:var(--muted);}'
    + '.hale .blend-sum{display:flex;align-items:baseline;flex-wrap:wrap;gap:6px 12px;margin-top:12px;}'
    + '.hale .blend-sum b{font-family:var(--serif);font-weight:400;font-size:24px;color:var(--ink);line-height:1;}'
    + '.hale .blend-sum em{font-style:normal;font-size:12.5px;color:var(--muted);}'
    + '.hale .blend-note{margin-top:14px;}'
    /* bigger, button-like toggle for the blend note */
    + '.hale .blend-toggle{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;box-sizing:border-box;'
      + 'min-height:50px;padding:13px 18px;border:1px solid var(--accent);border-radius:12px;'
      + 'background:color-mix(in srgb, var(--accent) 7%, transparent);'
      + 'font-family:var(--serif);text-transform:uppercase;letter-spacing:.06em;font-size:13px;'
      + 'color:var(--accent);cursor:pointer;text-decoration:none;transition:.2s;}'
    + '.hale .blend-toggle:hover{background:var(--accent);color:var(--on-accent);}'
    + '.hale .blend-toggle svg{width:18px;height:18px;flex:0 0 auto;transition:transform .25s ease;}'
    + '.hale .blend-toggle.open svg{transform:rotate(45deg);}'
    + '.hale .blend-field{margin-top:10px;}'
    + '.hale .blend-field[hidden]{display:none;}'
    + '.hale .blend-field textarea{width:100%;box-sizing:border-box;min-height:96px;padding:13px 15px;border:1px solid var(--line);border-radius:12px;background:var(--bg-2);color:var(--ink);font-family:var(--sans);font-size:14.5px;line-height:1.5;resize:vertical;outline:none;}'
    + '.hale .blend-field textarea:focus{border-color:var(--accent);}'
    + '.hale .blend-field small{display:block;margin-top:7px;font-size:12px;color:var(--muted);line-height:1.45;}'
    + '.hale .pinfo[data-blend] .vpicker{display:none !important;}'
    + '.hale .pinfo[data-blend] .qty{display:none !important;}'
    + '.hale .pinfo[data-blend] .pdp-form .qtyrow{gap:0;}'
    + '.hale .pinfo[data-blend] .pprice .pprice-sub{display:none;}'
    + '@media(max-width:560px){.hale .blend-toggle{font-size:12.5px;letter-spacing:.04em;min-height:52px;}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var pills = STEPS.map(function(g,i){
      return '<button type="button" class="blend-pill'+(i===0?' on':'')+'" data-g="'+g+'">'+g+' \u0433</button>';
    }).join('') + '<button type="button" class="blend-pill" data-g="custom">\u0406\u043d\u0448\u0430</button>';

    var box = document.createElement('div');
    box.className = 'blend';
    box.innerHTML =
      '<span class="blend-lbl">\u0412\u0430\u0433\u0430 \u0437\u0431\u043e\u0440\u0443</span>'
      + '<div class="blend-pills" data-bpills>'+pills+'</div>'
      + '<div class="blend-custom" data-bcustom>'
        + '<input type="number" inputmode="numeric" min="'+MIN+'" max="'+MAX+'" step="10" value="70" aria-label="\u0412\u0430\u0433\u0430 \u0432 \u0433\u0440\u0430\u043c\u0430\u0445" data-bg>'
        + '<span>\u0433\u0440\u0430\u043c\u0456\u0432 \u00b7 \u0432\u0456\u0434 '+MIN+' \u0434\u043e '+MAX+'</span>'
      + '</div>'
      + '<div class="blend-sum"><b data-btotal></b><em data-bper></em></div>'
      + '<div class="blend-note">'
        + '<button type="button" class="blend-toggle" data-bnote>'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12h14"/></svg>'
          + '\u0412\u043a\u0430\u0437\u0430\u0442\u0438 \u0441\u043a\u043b\u0430\u0434 \u0430\u0431\u043e \u043f\u043e\u0431\u0430\u0436\u0430\u043d\u043d\u044f'
        + '</button>'
        + '<div class="blend-field" data-bfield hidden>'
          + '<textarea data-btext placeholder="\u041d\u0430\u043f\u0440.: \u0440\u043e\u043c\u0430\u0448\u043a\u0430, \u043c\u0435\u043b\u0456\u0441\u0430, \u043b\u0438\u043f\u0430 \u2014 \u0431\u0435\u0437 \u043f\u043e\u043b\u0438\u043d\u0443"></textarea>'
          + '<small>\u0424\u0456\u0442\u043e\u0442\u0435\u0440\u0430\u043f\u0435\u0432\u0442 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u044c \u0441\u0443\u043c\u0456\u0441\u043d\u0456\u0441\u0442\u044c \u0442\u0440\u0430\u0432 \u0456 \u043d\u0430\u043f\u0438\u0448\u0435, \u044f\u043a\u0449\u043e \u0449\u043e\u0441\u044c \u0442\u0440\u0435\u0431\u0430 \u0437\u0430\u043c\u0456\u043d\u0438\u0442\u0438.</small>'
        + '</div>'
      + '</div>';

    var buybox = root.querySelector('.buybox');
    if(buybox && buybox.parentNode) buybox.parentNode.insertBefore(box, buybox);
    else root.appendChild(box);

    var form   = root.querySelector('#pdpForm');
    var qtyEl  = root.querySelector('#qty');
    var totalEl= box.querySelector('[data-btotal]');
    var perEl  = box.querySelector('[data-bper]');
    var customW= box.querySelector('[data-bcustom]');
    var gInput = box.querySelector('[data-bg]');
    var noteBtn= box.querySelector('[data-bnote]');
    var field  = box.querySelector('[data-bfield]');
    var textEl = box.querySelector('[data-btext]');
    var btnPr  = root.querySelector('#btnPrice');
    var mainPr = root.querySelector('#priceMain');
    var stickPr= document.querySelector('#pstickPrice');

    var propInput = document.createElement('input');
    propInput.type = 'hidden';
    propInput.name = 'properties[\u0421\u043a\u043b\u0430\u0434 \u0437\u0430 \u0437\u0430\u043f\u0438\u0442\u043e\u043c]';
    var gramProp = document.createElement('input');
    gramProp.type = 'hidden';
    gramProp.name = 'properties[\u0412\u0430\u0433\u0430]';
    if(form){ form.appendChild(propInput); form.appendChild(gramProp); }

    sel.value = gramOpt.value;
    var grams = STEPS[0];

    function paint(){
      var total = perGram * grams;
      if(totalEl) totalEl.textContent = money(total);
      if(perEl)   perEl.textContent = '\u2248 ' + money(perGram * 50) + ' / 50 \u0433';
      if(qtyEl){ qtyEl.value = grams; }
      if(gramProp) gramProp.value = grams + ' \u0433';
      if(btnPr)  btnPr.textContent  = money(total);
      if(mainPr) mainPr.textContent = money(total);
      if(stickPr) stickPr.textContent = money(total);
    }

    box.querySelectorAll('.blend-pill').forEach(function(p){
      p.addEventListener('click', function(){
        box.querySelectorAll('.blend-pill').forEach(function(x){ x.classList.remove('on'); });
        p.classList.add('on');
        if(p.dataset.g === 'custom'){
          customW.classList.add('on');
          grams = Math.max(MIN, Math.min(MAX, parseInt(gInput.value,10) || 70));
          gInput.value = grams;
          setTimeout(function(){ gInput.focus(); gInput.select(); }, 40);
        } else {
          customW.classList.remove('on');
          grams = parseInt(p.dataset.g, 10);
        }
        paint();
      });
    });

    if(gInput) gInput.addEventListener('input', function(){
      var v = parseInt(gInput.value, 10);
      if(!isFinite(v)) return;
      grams = Math.max(MIN, Math.min(MAX, v));
      paint();
    });
    if(gInput) gInput.addEventListener('blur', function(){
      gInput.value = grams;
      paint();
    });

    if(noteBtn) noteBtn.addEventListener('click', function(){
      var open = field.hidden;
      field.hidden = !open;
      noteBtn.classList.toggle('open', open);
      if(open) setTimeout(function(){ textEl.focus(); }, 40);
    });
    if(textEl) textEl.addEventListener('input', function(){
      propInput.value = textEl.value.trim();
    });

    if(form) form.addEventListener('submit', function(){
      if(qtyEl) qtyEl.value = grams;
      if(textEl) propInput.value = textEl.value.trim();
      if(gramProp) gramProp.value = grams + ' \u0433';
      sel.value = gramOpt.value;
    }, true);

    paint();
  }

  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  setTimeout(boot, 700);
  document.addEventListener('shopify:section:load', boot);
})();
